import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWith401Handling } from './baseQueryWith401Handling';
import AuthenticatedUser from '../models/AuthenticatedUserModel';

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: baseQueryWith401Handling,
    endpoints: (builder) => ({
        checkAuth: builder.query<AuthenticatedUser, void>({
            query:() => ({
                url: "authentication/getUser"
            })
        })
    }),
});

export const {
    useLazyCheckAuthQuery,
    useCheckAuthQuery
  } = authApi;